import httpHelper from "@/helpers/httpHelper";
// action types
export const CONFIRM_INTERNAL_TRANSFER = "confirmInternalTransfer";
export const REJECT_INTERNAL_TRANSFER = "rejectInternalTransfer";


export default {
    state: {

    },
    getters: {

    },
    actions: {


        /**
         * send request for confirm internal transfer
         * @param state
         * @param payload
         */
        [CONFIRM_INTERNAL_TRANSFER](context, payload) {

            return new Promise((resolve, reject) => {
                httpHelper
                    .getData('internal_transfer/accept/' + payload)
                    .then((response) => {
                        resolve(response)
                    }).catch((error) => {
                        reject(error)
                    })
            });
        },
        /**
         * send request for reject internal transfer
         * @param state
         * @param payload
         */
        [REJECT_INTERNAL_TRANSFER](context, payload) {

            return new Promise((resolve, reject) => {
                httpHelper
                    .getData('internal_transfer/decline/' + payload)
                    .then((response) => {
                        resolve(response)
                    }).catch((error) => {
                        reject(error)
                    })
            });
        },
    },
    mutations: {

    }
};